export const Logo: React.FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
      <img style={{ width: 18, height: 24, marginRight: 8 }} src="/logo.svg" alt="TezApp" />
      <img style={{ width: 78, height: 20 }} src="/app-name.svg" alt="TezApp" />
    </div>
  );
};
